export const AwakenedChampionAddress = '0x6e3EC1E0CE57246c2E573cA939c699205AcbF08b';
